import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import api from "@/lib/api";

// SEC-002 fix: fetch the logo with an authenticated request (Bearer header)
// instead of embedding the session token in the <img> URL query string.
const cache = new Map();

export const ClientLogo = ({ client, alt, iconClass = "w-7 h-7 text-zinc-400" }) => {
  const [src, setSrc] = useState(() => cache.get(client?.id) || null);
  useEffect(() => {
    let alive = true;
    if (!client?.logo_path) { setSrc(null); return undefined; }
    if (cache.has(client.id)) { setSrc(cache.get(client.id)); return undefined; }
    api.get(`/clients/${client.id}/logo`, { responseType: "blob" })
      .then((r) => {
        const url = URL.createObjectURL(r.data);
        cache.set(client.id, url);
        if (alive) setSrc(url);
      })
      .catch(() => { if (alive) setSrc(null); });
    return () => { alive = false; };
  }, [client?.id, client?.logo_path]);
  if (!src) return <Building2 className={iconClass} />;
  return <img src={src} alt={alt || client?.name || "logo"} className="w-full h-full object-contain" />;
};

export default ClientLogo;
